import { render } from "./ModalTable.html?vue&type=template&id=a3f2a5bc&scoped=true"
import script from "./ModalTable.js?vue&type=script&lang=js"
export * from "./ModalTable.js?vue&type=script&lang=js"

import "./ModalTable.css?vue&type=style&index=0&id=a3f2a5bc&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f2a5bc"]])

export default __exports__